import { Theme, createStyles } from '@material-ui/core';

export const styles = (theme: Theme) =>
    createStyles({
        root: {
            fontFamily: 'MuseoSans, sans-serif',
            width: '56.8%',
            maxWidth: '820px',
            marginBottom: '60px',
            marginLeft: '28.19%',
            '& p': {
                fontSize: '13px',
                color: theme.palette.primary.main,
                letterSpacing: '0.53px',
                lineHeight: '18.35px',
                marginTop: '12px',
            },
            '& p:first-child': {
                marginTop: 0,
            },
            [theme.breakpoints.up(1441)]: {
                margin: '0 auto 60px auto',
            },
            [theme.breakpoints.down(1300)]: {
                width: '70%',
                marginLeft: '15%',
            },
            [theme.breakpoints.down(1050)]: {
                width: '85%',
                marginLeft: '10%',
                '& p': {
                    fontSize: '9.9px',
                    letterSpacing: '0.49px',
                    lineHeight: '14px',
                },
            },
            [theme.breakpoints.down(850)]: {
                width: '70.7%',
                marginLeft: '22%',
                marginBottom: '30px',
                '& p': {
                    fontSize: '6.86px',
                    letterSpacing: '0.45px',
                    lineHeight: '9.91px',
                },
            },
        },
    });
